import  axiosI  from '../Service/service';
import {
    GET_PROFILE,
    ENABLE,
    DISABLE,
    GET_ACCOUNT_DETAIL,
    UPDATE_NAME,
    UPDATE_USERNAME,
    UPDATE_EMAIL,
    UPDATE_PHONE,
    UPDATE_BIO,
    UPDATE_ADDRESS
} from './actionTypes';
import * as constants from '../Constants';

export const getAccountDetailAction=(businessId)=>{
    return (dispatch => {
        return axiosI.post(constants.API.getBusinessAccountDetailsApi,{BusinessID:businessId}).then(({data})=>{
            dispatch({
                type: GET_ACCOUNT_DETAIL,
                payload: data.results
            });
        })
    })
};

export const updateName = (data) => {
    return dispatch =>
        dispatch({
            type: UPDATE_NAME,
            payload: data
        });
};

export const updateUserName = (data) => {
    return dispatch =>
        dispatch({
            type: UPDATE_USERNAME,
            payload: data
        });
};

export const updateEmail = (data) => {
    return dispatch =>
        dispatch({
            type: UPDATE_EMAIL,
            payload: data
        });
};

export const updatePhone = (data) => {
    return dispatch =>
        dispatch({
            type: UPDATE_PHONE,
            payload: data
        });
};

export const addressUpdated = (data) => {
    return dispatch =>
        dispatch({
            type: UPDATE_ADDRESS,
            payload: data
        });
};

export const enableLoading = () => {
    return dispatch =>
        dispatch({
            type:ENABLE,
            payload:true
        });
};

export const disableLoading = () => {
    return dispatch =>
        dispatch({
            type:DISABLE,
            payload:false
        });
};

export const updateProfileBio = (AppUserID,Bio) => {

  return (dispatch => {
    return axiosI.post(constants.API.updateProfileBioApi,{AppUserId:AppUserID,Bio:Bio}).then(()=>{
      dispatch({
        type: UPDATE_BIO,
        payload: Bio
      });
    })
  })
};